import i18next from 'i18next';
import { FALLBACK_LANGUAGE } from '@/i18n/supportedLanguages';

export function resolveActiveLanguage(): string {
  if (typeof i18next.language === 'string' && i18next.language.length > 0) {
    return i18next.language;
  }
  return FALLBACK_LANGUAGE;
}
